import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import wheelchairImage from '../../assets/services/wheelchair.jpg';
import { FaWheelchair, FaUserNurse, FaCarAlt, FaHandHoldingHeart } from 'react-icons/fa';

function MobiliteReduite() {
  const features = [
    {
      icon: <FaWheelchair />,
      title: "Accès Adapté",
      description: "Véhicules spécialement aménagés pour fauteuils roulants"
    },
    {
      icon: <FaUserNurse />,
      title: "Personnel Qualifié",
      description: "Chauffeurs formés à l'assistance des personnes à mobilité réduite"
    },
    {
      icon: <FaCarAlt />,
      title: "Équipement Spécialisé",
      description: "Rampes d'accès, systèmes de fixation et équipements de sécurité"
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Assistance Complète",
      description: "Aide personnalisée du départ jusqu'à l'arrivée"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${wheelchairImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Mobilité Réduite</h1>
          <p>Transport adapté et assistance personnalisée</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Service de Transport Adapté</h2>
            <p>
              Notre service de transport pour personnes à mobilité réduite est conçu 
              pour offrir un maximum de confort et de sécurité. Nos véhicules sont 
              spécialement équipés pour accueillir les fauteuils roulants et faciliter 
              les déplacements.
            </p>
            <p>
              Nos chauffeurs qualifiés sont formés pour fournir une assistance 
              personnalisée et attentionnée, garantissant un voyage confortable et 
              sécurisé pour tous nos passagers à mobilité réduite.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Réservez Votre Transport</h2>
            <p>
              Contactez-nous pour organiser votre transport adapté en toute sérénité.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default MobiliteReduite; 